export const MODAL_TYPE_DISCARD_COMMENT = 'discard-comment';
